/**
 * The New-document → Compose hand-off.
 *
 * A document must exist before it can be composed into, so the instructions have to survive
 * one navigation. kms passed them through **session storage**, not a query param, and
 * deliberately: a reload must not re-run the compose. Reading the key CONSUMES it, which is
 * what makes that true.
 */
const PREFIX = "sculpt.compose.";

export function stashCompose(documentId: string, instructions: string): void {
  try {
    sessionStorage.setItem(`${PREFIX}${documentId}`, JSON.stringify({ instructions }));
  } catch {
    // A private window with storage denied loses the hand-off; it must not lose the document.
  }
}

/** Reads AND clears. A second call, or a reload, gets nothing — by design. */
export function takeCompose(documentId: string): string {
  try {
    const raw = sessionStorage.getItem(`${PREFIX}${documentId}`);
    if (!raw) {
      return "";
    }
    sessionStorage.removeItem(`${PREFIX}${documentId}`);
    const parsed = JSON.parse(raw) as { instructions?: unknown };
    return typeof parsed.instructions === "string" ? parsed.instructions : "";
  } catch {
    return "";
  }
}
